// Tracks markets that have been claimed in this session.
// Used to hide positions immediately after claim, before the backend
// processes the PayoutRedemption event and updates is_claimed in DB.
// Keyed by wallet address to prevent cross-account state leakage.
import { create } from 'zustand';

interface ClaimState {
  // Key format: "walletAddress:marketAddress" (both lowercased)
  claimedKeys: Set<string>;
  markClaimed: (walletAddress: string, marketAddress: string) => void;
  isClaimedForWallet: (walletAddress: string, marketAddress: string) => boolean;
}

const makeKey = (wallet: string, market: string) =>
  `${wallet.toLowerCase()}:${market.toLowerCase()}`;

export const useClaimStore = create<ClaimState>((set, get) => ({
  claimedKeys: new Set<string>(),
  markClaimed: (walletAddress: string, marketAddress: string) => {
    set(state => {
      const next = new Set(state.claimedKeys);
      next.add(makeKey(walletAddress, marketAddress));
      return { claimedKeys: next };
    });
  },
  isClaimedForWallet: (walletAddress: string, marketAddress: string) => {
    return get().claimedKeys.has(makeKey(walletAddress, marketAddress));
  },
}));

// Backward-compatible exports (used by claim-button.tsx)
export const markMarketClaimed = (walletAddress: string, marketAddress: string) => {
  useClaimStore.getState().markClaimed(walletAddress, marketAddress);
};
